export default __webpack_public_path__ + "static/media/comment-outline-16px.ec579dda.svg";